var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitNotEqualsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C10.1217 7.07185e-06 12.1569 0.842489 13.6572 2.34277C15.1575 3.84306 16 5.87827 16 8C16 10.1217 15.1575 12.1569 13.6572 13.6572C12.1569 15.1575 10.1217 16 8 16C5.87827 16 3.84306 15.1575 2.34277 13.6572C0.842482 12.1569 0 10.1217 0 8C1.76798e-06 5.87827 0.842484 3.84306 2.34277 2.34277C3.84306 0.842493 5.87828 0 8 0ZM10.4307 4.0127C10.1834 3.83774 9.84857 3.90959 9.68359 4.17188L8.58594 5.91699H5.01562C4.71784 5.91699 4.47665 6.17224 4.47656 6.48828C4.47656 6.8044 4.71779 7.05957 5.01562 7.05957H7.86719L6.79102 8.77441H5.01562C4.71789 8.77441 4.47672 9.02973 4.47656 9.3457C4.47656 9.66182 4.71779 9.91797 5.01562 9.91797H6.07422L5.37402 11.0283C5.20915 11.2908 5.27619 11.6462 5.52344 11.8213C5.77079 11.9963 6.1056 11.9246 6.27051 11.6621L7.36816 9.91797H10.9385C11.2363 9.91797 11.4766 9.66182 11.4766 9.3457C11.4764 9.02973 11.2362 8.77441 10.9385 8.77441H8.08594L9.16309 7.05957H10.9385C11.2363 7.05957 11.4766 6.8044 11.4766 6.48828C11.4765 6.17224 11.2363 5.91699 10.9385 5.91699H9.87988L10.5801 4.80566C10.7447 4.54317 10.6779 4.18767 10.4307 4.0127Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitNotEqualsCircle);
export default __webpack_public_path__ + "static/media/aitNotEqualsCircle.3008a4abf82040e037cab446a34c959e.svg";
export { ForwardRef as ReactComponent };